<template>
  <div>
    <FilterSimpleSlot
      :headers="headers"
      :data="show"
      :days="propDays"
      :paginate="paginate"
      :filterPrincipal="filterPrincipal"
      :filter="filters"
      @reload="$refs['ref-table-rrhh-attendance-justifications'].refresh()"
    >
      <template #buttons>
        <b-button
          variant="info"
          v-b-tooltip.hover.top="$t('Download Excel')"
          @click="exportToExcel"
        >
          <feather-icon icon="FileTextIcon" /> Excel
        </b-button>
      </template>
      <template #table>
        <b-table
          ref="ref-table-rrhh-attendance-justifications"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative font-small-3"
          table-class="text-nowrap"
          :items="myProvider"
          show-empty
          :empty-text="$t('No records found')"
          :fields="showFields"
          :busy.sync="isBusy"
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="fields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>

          <template #cell(personal_name)="data">
            <div class="d-flex">
              <div class="d-flex">
                <feather-icon icon="UserIcon" size="22" class="text-success" />
              </div>
              <div class="ml-1">
                <router-link
                  target="_blank"
                  :class="[textLink]"
                  :to="{
                    name: 'rrhh-employees-information',
                    params: { id: data.item.personal_id },
                  }"
                >
                  {{ data.item.personal_name | capitalize }}
                </router-link>
              </div>
            </div>
          </template>

          <template #cell(justification_type)="data">
            <span>
              {{ $t(data.item.justification_type) }}
            </span>
          </template>

          <template #cell(justification_status)="data">
            <span>
              <b-badge
                v-if="data.item.justification_status == 'Approved By Chief'"
                variant="light-success"
                class="ml-1"
              >
                {{ $t("Approved By Chief") }}
              </b-badge>

              <b-badge
                v-if="
                  data.item.justification_status == 'Pending' ||
                  data.item.justification_status == 'Pending to approve'
                "
                variant="light-warning"
                class="ml-1"
              >
                {{ $t("Pending") }}
              </b-badge>

              <b-badge
                v-if="data.item.justification_status == 'Approved By HR'"
                variant="light-success"
                class="ml-1"
              >
                {{ $t("Approved By HR") }}
              </b-badge>

              <b-badge
                v-if="data.item.justification_status == 'Rejected By HR'"
                variant="light-danger"
                class="ml-1"
              >
                {{ $t("Rejected By HR") }}
              </b-badge>
            </span>
          </template>

          <template #cell(created_by)="data">
            <span>
              {{ data.item.created_by | capitalize }}
            </span>
            <br />
            <span>
              {{ data.item.justification_created_at | prettyDate }}
            </span>
          </template>

          <template #cell(actions)="data">
            <feather-icon
              icon="EyeIcon"
              size="15"
              class="text-primary cursor-pointer mr-50"
              @click="reviewJustificationModal(data.item)"
            />
          </template>
        </b-table>
      </template>
    </FilterSimpleSlot>

    <ReviewJustificationModal
      v-if="showReviewJustificationModal"
      :justifiationId="justifiationId"
      :isView="isView"
      @close="showReviewJustificationModal = false"
      @hidden="showReviewJustificationModal = false"
      @updated="reviewJustificationModalUpdated"
    />
  </div>
</template>
<script>
import moment from "moment";
import { mapGetters } from "vuex";
import AttendanceService from "@/views/rrhh/views/attendance/services/attendance.service.js";
import { ClipboardIcon, ClipboardCopyIcon } from "vue-tabler-icons";
import Fields from "@/views/commons/employee_attendance/data/attendance-justifications.fields.js";
import FilterSimpleSlot from "@/views/commons/filter-slot/FilterReportSimpleSlot.vue";
import ReviewJustificationModal from "@/views/commons/employee_attendance/justifications/modals/ModalReviewJustification.vue";
import Filters from "@/views/commons/employee_attendance/data/filters.justificaciones.js";
import EmployeeService from "@/views/rrhh/views/employees/services/employee.service.js";

export default {
  name: "AttendanceJustifications",
  components: {
    FilterSimpleSlot,
    ClipboardIcon,
    ClipboardCopyIcon,
    ReviewJustificationModal,
  },
  data() {
    return {
      filters: Filters,
      justifiationId: "",
      showReviewJustificationModal: false,
      show: [],
      min: new Date(1950, 0, 1, 0, 0, 0),
      max: new Date(3049, 11, 31, 24, 0, 0),
      week: 0,
      hearChange: "",
      days: {
        monday: "",
        tuesday: "",
        wednesday: "",
        thursday: "",
        friday: "",
        saturday: "",
        sunday: "",
      },
      module_id: this.$route.matched[0].meta?.module,
      datesAdd: [],
      users: [],
      headers: [
        {
          name: "User",
        },
      ],
      propDays: [],
      isBusy: false,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "Search...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      fields: Fields,
      currentMonth: new Date().getMonth() + 1,
      isView: false,
    };
  },
  created() {
    this.addPreloader();
    this.getAreas();
    this.listJustificationTypes();
  },
  methods: {
    async listJustificationTypes() {
      try {
        this.addPreloader();
        const { data } = await AttendanceService.listJustificationTypes();

        data.forEach((item) => {
          item.name = this.$t(item.name);
        });

        this.filters[3].options = data;
      } catch (error) {
        this.showToastError();
      } finally {
        this.removePreloader();
      }
    },
    async getAreas() {
      try {
        const { data } = await EmployeeService.getAllAreas({
          moduleId: this.currentUser.modul_id,
        });
        this.filters[2].options = data;
      } catch (error) {
        console.log(error);
      }
    },
    async myProvider(ctx) {
      let orderBy = 1;

      switch (ctx.sortBy) {
        case "personal_name":
          orderBy = 1;
          break;
        case "justification_date":
          orderBy = 5;
          break;
        case "justification_type":
          orderBy = 4;
          break;
        default:
          orderBy = 1;
          break;
      }

      try {
        this.addPreloader();
        const params = {
          search: this.filterPrincipal.model,
          tab: this.searchStatus,
          order: ctx.sortDesc ? "desc" : "asc",
          orderBy: orderBy,
          npage: ctx.currentPage,
          perpage: ctx.perPage,

          from: this.filters[0].model,
          to: this.filters[1].model,
          area_id: this.filters[2].model,
          tipo_justificacion: this.filters[3].model,
        };

        const { data } =
          await AttendanceService.listEmployeeJustificationsByStatus(params);

        this.paginate.currentPage = data.current_page;
        this.paginate.perPage = data.per_page;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.from = data.from;

        return data.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    async exportToExcel(ctx) {
      let orderBy = 1;

      switch (ctx.sortBy) {
        case "personal_name":
          orderBy = 1;
          break;
        case "justification_date":
          orderBy = 5;
          break;
        case "justification_type":
          orderBy = 3;
          break;
        default:
          orderBy = 1;
          break;
      }

      try {
        this.addPreloader();
        const params = {
          search: this.filterPrincipal.model,
          tab: this.searchStatus,
          order: ctx.sortDesc ? "desc" : "asc",
          orderBy: orderBy,
          npage: ctx.currentPage,
          perpage: ctx.perPage,

          from: this.filters[0].model,
          to: this.filters[1].model,
          area_id: this.filters[2].model,
          tipo_justificacion: this.filters[3].model,
        };

        const response =
          await AttendanceService.listEmployeeJustificationsByStatusExcel(
            params
          );

        let filename = "justificaciones.xlsx";
        const disposition = response.headers["content-disposition"];

        if (disposition && disposition.includes("filename=")) {
          filename = disposition
            .split("filename=")[1]
            .replace(/['"]/g, "")
            .trim();
        }

        this.forceFileDownload(response.data, filename);
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },

    reviewJustificationModalUpdated() {
      this.isView = true;
      this.showReviewJustificationModal = false;
      this.$refs["ref-table-rrhh-attendance-justifications"].refresh();
    },

    async reviewJustificationModal(data) {
      try {
        this.isView = this.getTab == 1 ? false : true;
        this.showReviewJustificationModal = true;
        this.justifiationId = data.id;
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    getTab() {
      // return this.$route.matched[3].meta.tab; // verificar al implementar en otros modulos
      return this.$route.meta.tab;
    },

    searchStatus() {
      // if route is rrhh-attendance-justifications-pending status is 1 else if route is rrhh-attendance-justifications-completed status is 2
      if (
        this.$route.name == "rrhh-payroll-attendance-justifications-pending" ||
        this.$route.name == "workshop-attendance-justifications-pending" ||
        this.$route.name == "treasury-attendance-justifications-pending"
      ) {
        return 1;
      } else if (
        this.$route.name ==
          "rrhh-payroll-attendance-justifications-completed" ||
        this.$route.name == "workshop-attendance-justifications-completed" ||
        this.$route.name == "treasury-attendance-justifications-completed"
      ) {
        return 2;
      }
    },
    showFields() {
      return this.fields.filter((field) => field.visible);
    },
  },
};
</script>